
var Submenu = (function() {

    function Submenu(toggle, dropdown) {
        var self = this;
        this.toggle = toggle;
        this.dropdown = dropdown;

        this.toggle.addEventListener('click', function(event) {
            event.preventDefault();
            self.toggle.classList.toggle('c-navbar-dropdown-toggle-active');
            self.dropdown.classList.toggle('c-navbar-dropdown-hidden');
        });
    }

    return Submenu;
}());

var Navbar = (function() {

    function Navbar(id) {
        var self = this;
        this.el = document.getElementById(id);

        this.menuToggle = this.el.getElementsByClassName('c-navbar-toggle')[0];
        this.menuWrapper = this.el.getElementsByClassName('c-navbar-menu-wrapper')[0];
        this.overlay = document.getElementById('overlay');
        
        this.menuToggle.addEventListener('click', function(event) {
            event.preventDefault();
            self.menuToggle.classList.toggle('c-navbar-toggle-active');
            self.menuWrapper.classList.toggle('c-navbar-menu-wrapper-hidden');
            self.overlay.classList.toggle('o-overlay-active');
        })

        this.submenus = [];
        var itemsWithChildren = this.el.getElementsByClassName('c-navbar-menu-item-has-children');
        var idx = 0;
        for (; idx < itemsWithChildren.length; idx++) {
            var item = itemsWithChildren[idx];
            var submenu = new Submenu(
                item.getElementsByClassName('c-navbar-dropdown-toggle')[0],
                item.getElementsByClassName('c-navbar-dropdown')[0]
            );
            self.submenus.push(submenu);
        }
        
    }

    return Navbar;
}());

export default Navbar;
